export const sampleCsv = `Test name,Test step,Test data,Expected result,Component,Version
Log in,Enter sample page,www.example.com,The sample page shows up,"component 1, component 2","version 1, version 2"
Log in,Click on the “log-in” button,,The log-in form is shown,,
Log in,Enter username and password,"user: admin, password: password",The username is visible and the password is masked,,
Log in,Click enter,,The user is logged in and redirected to the home page,,
Log out,Enter sample page,www.example.com,The sample page shows up,component 1,version 1
Log out,Click on the “log-out” button,,The user is redirected to log-in page,,`;
